module.exports = __webpack_public_path__ + "b2e572d84e781844366bc76c95b985d0.svg";